import { t } from "i18next";
import TabsMobile from "../__template/TabsMobileComponent";
import { Tab } from "@headlessui/react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import Config from "../../config/Config";
const baseUrl = Config.BaseUrlRecitationDev;

export const RecitationDetailMobile = () => {
  const location: any = useLocation();
  const [child, setChild] = useState<any>({});

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  useEffect(() => {
    setChild(location.state.data);
    console.log(location.state.data);
  }, []);

  function getAudioContent(url: string) {
    return baseUrl + "audio/get/" + url;
  }
  return (
    <>
      <div className="relative min-h-screen h-screen bg-psp-primary pb-10 font-montserrat">
        {/* <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
                <TabsMobile
                    name={`${t("RECITATION.recitationDetail")}`}
                    backUrl={"home"}
                ></TabsMobile>
            </div> */}
        <div className="bg-white min-h-screen">
          <Tab.Group>
            <Tab.List className="flex flex-row justify-around border-b sticky top-0 bg-white">
              <Tab
                className={({ selected }) =>
                  classNames(
                    "py-2.5 text-sm w-full",
                    " ",
                    selected
                      ? `font-montserrat rounded-xl text-sm font-bold text-psp-primary underline underline-offset-4 decoration-2`
                      : "text-gray-400 bg-none font-montserrat font-medium"
                  )
                }
              >
                Hafalan
              </Tab>
              <Tab
                className={({ selected }) =>
                  classNames(
                    "py-2.5 text-sm w-full",
                    " ",
                    selected
                      ? `font-montserrat rounded-xl text-sm font-bold text-psp-primary underline underline-offset-4 decoration-2`
                      : "text-gray-400 bg-none font-montserrat font-medium"
                  )
                }
              >
                Nilai
              </Tab>
            </Tab.List>
            <Tab.Panels className="min-h-screen">
              <Tab.Panel className="p-4">
                <section className="">
                  <p className="font-bold text-dark text-sm">Informasi Umum</p>
                  <table className="w-full">
                    <tbody>
                      <tr className="text-sm">
                        <td width="35%" className="p-1">
                          Tanggal Setoran
                        </td>
                        <td>:</td>
                        <td className="text-right">
                          {moment(child.tanggalSetoran)
                            .locale("id")
                            .format("LL HH:mm")}
                        </td>
                      </tr>
                      <tr className="text-sm">
                        <td width="30%" className="p-1">
                          Nama Guru
                        </td>
                        <td>:</td>
                        <td className="text-right">{child.namaMusyrif}</td>
                      </tr>
                      <tr className="text-sm">
                        <td width="30%" className="p-1">
                          Nama Siswa
                        </td>
                        <td>:</td>
                        <td className="text-right">
                          {child.detailMurid?.callerName}
                        </td>
                      </tr>
                      <tr className="text-sm">
                        <td width="30%" className="p-1">
                          Tipe Setoran
                        </td>
                        <td>:</td>
                        <td className="text-right">{child.tipeSetoran}</td>
                      </tr>
                      <tr className="text-sm">
                        <td width="30%" className="p-1">
                          Subtipe Setoran
                        </td>
                        <td>:</td>
                        <td className="text-right">{child.surat}</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
                <section className="mt-4">
                  <p className="font-bold text-dark text-sm">
                    Informasi Setoran
                  </p>
                  <label htmlFor="">Dari</label>
                  <input
                    type="text"
                    value={child.start}
                    disabled
                    className="w-full bg-psp-primary border border-1 p-2 rounded-md"
                  />
                  <label htmlFor="">Sampai</label>
                  <input
                    type="text"
                    value={child.finish}
                    disabled
                    className="w-full bg-psp-primary border border-1 p-2 rounded-md"
                  />
                  <label htmlFor="">Deskripsi</label>
                  <textarea
                    name=""
                    id=""
                    disabled
                    className="bg-psp-primary border border-1 w-full p-2"
                    rows={8}
                    value={child.description}
                  ></textarea>
                  {child.isAudioHafalan &&
                    child.audioHafalan.length &&
                    child.audioHafalan.map((item: any) => {
                      return (
                        <div className="w-full mt-4 flex flex-col gap-2">
                          <label>File audio</label>
                          <audio controls>
                            <source src={getAudioContent(item.audioName)} />
                          </audio>
                        </div>
                      );
                    })}
                </section>
              </Tab.Panel>
              <Tab.Panel className="p-4">
                <section className="">
                  <p className="font-bold text-dark text-sm">Penilaian</p>
                  <table className="w-full">
                    <tbody>
                      {child.scores?.assessmentScore?.map((detail: any) => (
                        <tr className="text-xs">
                          <td width="50%" className="py-2 font-base">
                            {detail.name}
                          </td>
                          <td width={10}>:</td>
                          <td width="40%">
                            <div className="w-full flex justify-end">
                              <input
                                type="text"
                                value={detail.score}
                                className="w-1/2 bg-psp-primary border border-1 rounded-md text-gray-500 py-1 px-2"
                                disabled
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <table className="w-full mt-2">
                    <tbody>
                      <tr className="text-xs">
                        <td width="50%" className="py-2 font-semibold">
                          Total
                        </td>
                        <td>:</td>
                        <td width="40%" className="text-right">
                          <div className="w-full flex justify-end">
                            <input
                              type="text"
                              value={child.scores?.total}
                              className="w-1/2 bg-psp-primary border border-1 rounded-md py-1 px-2 text-gray-500"
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                      <tr className="text-xs">
                        <td
                          width="50%"
                          className="py-2 font-semibold text-psp-primary"
                        >
                          Nilai Akhir
                        </td>
                        <td>:</td>
                        <td width="40%" className="text-right">
                          <div className="w-full flex justify-end">
                            <input
                              type="text"
                              value={child.scores?.finalScore}
                              className="w-1/2 bg-psp-primary border border-1 rounded-md py-1 px-2 text-gray-500"
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                      <tr className="text-xs">
                        <td width="50%" className="py-2 font-semibold">
                          Predikat
                        </td>
                        <td>:</td>
                        <td width="40%" className="text-right">
                          <div className="w-full flex justify-end">
                            <input
                              type="text"
                              value={child.scores?.predicateScore}
                              className="w-full bg-psp-primary border border-1 rounded-md py-1 px-2 text-gray-500"
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                      <tr className="text-xs">
                        <td width="50%" className="py-2 font-semibold">
                          Keterangan
                        </td>
                        <td>:</td>
                        <td width="40%" className="text-right">
                          <div className="w-full flex justify-end">
                            <input
                              type="text"
                              value={child.scores?.noteScore}
                              className="w-full bg-psp-primary border border-1 rounded-md py-1 px-2 text-gray-500"
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <label htmlFor="" className="text-xs mt-2">
                    Catatan
                  </label>
                  <textarea
                    name=""
                    id=""
                    rows={6}
                    value={child.scores?.description}
                    className="w-full bg-psp-primary border border-1 rounded-lg text-sm p-2"
                    disabled
                  ></textarea>
                </section>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    </>
  );
};
